import { useAuth } from "@/contexts/AuthContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { Building2, Check, LogOut, User as UserIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function UserMenu() {
  const { user, companies, activeCompanyId, switchCompany, logout } = useAuth();
  const nav = useNavigate();
  const activeCompany = companies.find((c) => c.id === activeCompanyId);

  if (!user) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="user-menu-trigger"
        className="flex items-center gap-2 px-3 py-1.5 rounded-md text-sm hover:bg-[#F3F1ED] transition-colors"
      >
        <div className="w-7 h-7 rounded-full bg-[#5C8065]/15 flex items-center justify-center">
          <UserIcon className="w-3.5 h-3.5 text-[#1F4E3D]" strokeWidth={1.5} />
        </div>
        <div className="text-left hidden sm:block">
          <div className="text-xs text-[#696E69] font-mono-num leading-none">
            {activeCompany?.name || "No workspace"}
          </div>
          <div className="text-sm leading-tight">{user.name}</div>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 bg-white" data-testid="user-menu">
        <DropdownMenuLabel className="label-overline">Workspaces</DropdownMenuLabel>
        {companies.length === 0 ? (
          <div className="px-2 py-2 text-xs text-[#696E69]">No workspaces assigned</div>
        ) : (
          companies.map((c) => (
            <DropdownMenuItem
              key={c.id}
              onClick={() => switchCompany(c.id)}
              data-testid={`switch-company-${c.id}`}
              className="cursor-pointer flex items-center gap-2"
            >
              <Building2 className="w-3.5 h-3.5 text-[#696E69]" strokeWidth={1.5} />
              <span className="flex-1 truncate">{c.name}</span>
              {c.id === activeCompanyId && <Check className="w-3.5 h-3.5 text-[#1F4E3D]" strokeWidth={2} />}
            </DropdownMenuItem>
          ))
        )}
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="label-overline">{user.email}</DropdownMenuLabel>
        <DropdownMenuItem
          data-testid="logout-btn"
          onClick={() => {
            logout();
            nav("/login");
          }}
          className="cursor-pointer text-[#D26A59] focus:text-[#D26A59] flex items-center gap-2"
        >
          <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
